<!--
 * @Author: van
 * @Date: 2021-08-19 18:45:55
 * @LastEditors: van
 * @LastEditTime: 2021-09-26 18:41:20
-->
<template>
  <el-button-group class="search_btnGroup">
    <!-- <el-button class="el-icon-setting"
               size="small"
               type="primary"
               plain
               v-show="show=='all'"> Setting</el-button> -->
    <el-button class="el-icon-refresh"
               size="small"
               type="primary"
               plain
               @click="tableLoadingChange"> Refresh</el-button>
    <el-button class="icon-loudou iconfont_action"
               size="small"
               type="primary"
               plain
               v-if="show=='all'"
               @click="drawerChange"> Advance</el-button>
  </el-button-group>
</template>
<script>
export default {
    data() {
        return {};
    },
    methods: {
        tableLoadingChange() {
            this.$parent.search();
        },
        drawerChange() {
            this.$parent.drawerVisible = true;
        },
    },
    props: {
        menuAuth: {
            type: Array,
            default: []
        },
        funcName: String,
        show: {
            type: String,
            default: "all",
        },
    },
};
</script>
<style lang="scss" scoped>
.search_btnGroup {
    width: 200px;
    padding-top: 8px;
    // .el-button:focus {
    //     background: #fff;
    //     color: #606266;
    //     border-color: #ddd;
    // }
    // .el-button:hover {
    //     color: #40a9ff;
    //     border-color: #c6e5ff;
    //     background-color: #ecf6ff;
    // }
    .el-button {
        font-size: 12px;
        border-radius: 4px;
        color: $color-text-primary;
        font-weight: normal;
        background-color: #fff;
        border-color: #babfc3;
        border-top-right-radius: 0;
        border-bottom-right-radius: 0;
        &:last-child {
            border-top-left-radius: 0;
            border-bottom-left-radius: 0;
            border-top-right-radius: 3px;
            border-bottom-right-radius: 3px;
        }
        &:first-child {
            border-top-left-radius: 3px;
            border-bottom-left-radius: 3px;
        }
        &:not(:first-child):not(:last-child) {
            border-left-color: #babfc3;
            border-right-color: #babfc3;
        }
    }
}
</style>